<nav class="navbar-vertical navbar">
  <div class="vh-100 sidebar-color d-flex flex-column position-relative"
       [ngClass]="{ 'toggled': isSidebarToggled }">

    <a *ngIf="!isMobile">
      <img
        [attr.src]="isSidebarToggled ? './assets/images/svg/sidebar/logo-symbol.svg' : './assets/images/svg/sidebar/full-logo.svg'"
        alt="Sidebar Toggle"
        [ngClass]="isSidebarToggled ? 'symbol-spacing' : 'full-logo-spacing'">
    </a>

    <div class="mobile-sidebar-close-x" *ngIf="isMobile" (click)="toggleMobileMenu()">
      <a>
        <i>
          <img src="./assets/images/svg/sidebar/close-sidebar-x.svg" alt="Close Sidebar">
        </i>
      </a>
    </div>

    <a *ngIf="!isMobile" id="nav-toggle" (click)="toggleSidebarMenu()">
      <img src="./assets/images/svg/sidebar/close-sidebar.svg"
           alt="Nav Toggle"
           [ngClass]="{ 'rotate-180': isSidebarToggled, 'rotate-0': !isSidebarToggled }">
    </a>

    <ul class="navbar-nav mt-5 flex-column flex-grow-1"
        [ngClass]="{ 'toggled': isSidebarToggled, 'ml-3': isMobile }"
        id="sideNavbar">
      <li class="nav-item" *ngFor="let item of navItems" (click)="toggleMobileMenu()">
        <a class="nav-link mt-2" [routerLink]="item.route" routerLinkActive="active">
          <i [ngClass]="{ 'me-2': !isSidebarToggled }" [title]="item.title">
            <img [src]="getIconPath(item)" [alt]="item.label">
          </i>
          <span class="text-in-menu">{{ item.label }}</span>
        </a>
      </li>
      <li class="nav-item">
        <div class="nav-divider"></div>
      </li>
    </ul>

    <div class="mt-auto w-100 p-3" *ngIf="isMobile">
      <button class="btn btn-light custom-btn-color text-primary rounded-5 w-100" (click)="openQuizGenerationDialog()">
        Generate with AI
      </button>
      <button class="btn btn-light custom-btn-color text-primary rounded-5 mt-3 w-100" [routerLink]="['quiz/add']"
              (click)="toggleMobileMenu()">
        Create New Test
      </button>
    </div>
  </div>
</nav>
